import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	LikePetitionUpdate,
	type LikePetitionUpdateMutation,
	type LikePetitionUpdateMutationVariables,
} from './index.graphql';

export const likePetitionUpdate = async ({
	petitionUpdateId,
	like,
	utilityContext: {
		gql: { fetch },
	},
}: {
	petitionUpdateId: string;
	like: boolean;
	utilityContext: UtilityContext;
}): Promise<LikePetitionUpdateMutation | null | undefined> => {
	const { data: likeResult } = await fetch<LikePetitionUpdateMutation, LikePetitionUpdateMutationVariables>({
		query: LikePetitionUpdate,
		variables: {
			input: {
				petitionUpdateId,
				like,
			},
		},
		rejectOnError: false,
	});
	return likeResult;
};
